// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SoundTwoToneSvg from "@ant-design/icons-svg/es/asn/SoundTwoTone";
import AntdIcon from '../components/AntdIcon';

var SoundTwoTone = function SoundTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SoundTwoToneSvg
  }));
};

SoundTwoTone.displayName = 'SoundTwoTone';
export default React.forwardRef(SoundTwoTone);